import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiTrash } from "react-icons/bi"; 
import { BiSave } from "react-icons/bi"; 
import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxInput from '../../cx/CxInput';
import CxIcon from '../../cx/CxIcon';
import CxDate from '../../cx/CxDate';
import CxStatic from '../../cx/CxStatic';
import CxSnackbar from '../../cx/CxSnackbar';
import CxState from '../../cx/CxState';
import CxCombo from '../../cx/CxCombo';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import * as FxTable from '../../fx/FxTable';
import GxForm from '../../gx/GxForm';
import { StoreStockLot } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxAccordion from '../../cx/CxAccordion';
import CxTable from '../../cx/CxTable';
import { useNav } from '../../hx/useNav';


const MxStockroomLotForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_form = React.useRef(null);
  const r_accordion_sold = React.useRef(null);
  const r_table_sold = React.useRef(null);

  const rf_txLotCode = React.useRef(null);
  const rf_dtLotExpr = React.useRef(null);
  const rf_boActive = React.useRef(null);
  const rf_txLotAlert = React.useRef(null);
  const rf_txUse = React.useRef(null);
  const r_boLotConfigLoaded = React.useRef(false);

  const r_snack_ask_save = React.useRef(null);

  const [storeStockLot, ] = useSessionStorage('StoreStockLot', StoreStockLot);

  React.useEffect(() => {
    formLoadCustom();
    // eslint-disable-next-line
  }, []);

  const formLoadCustom = async () => {
    rf_txLotCode.current.setVal(storeStockLot.txLotCode);
    rf_dtLotExpr.current.setVal(storeStockLot.dtLotExpr);
    const boLotActive = String(storeStockLot.boLotActive);
    rf_boActive.current.setVal(boLotActive === '0' || boLotActive === '1' ? boLotActive : '1');

    const result = await FxFetch.doJsonX('stock/lots/config/r', {
      inPs: storeStockLot.inPs,
      txLotCode: storeStockLot.txLotCode,
    });
    if (!Array.isArray(result)) {
      FxLog.errorx('MxStockroomLotForm.formLoadCustom', 'Could not load lot settings');
      return;
    }

    const lotConfig = result[0];
    if (boLotActive !== '0' && boLotActive !== '1') {
      rf_boActive.current.setVal(lotConfig ? String(lotConfig.boActive) : '1');
    }
    rf_txLotAlert.current.setVal(lotConfig ? lotConfig.txLotAlert : '');
    rf_txUse.current.setVal(lotConfig ? lotConfig.txUse : 'x');
    r_boLotConfigLoaded.current = true;
  }

  const formDeleteCustom = () => {
    if (r_form.current.hasIncompleteRequired()) {
      return;
    }

    let record = {};
    record['inPs'] = storeStockLot.inPs;
    record['txPs'] = storeStockLot.txPs;
    record['txLotCodeOri'] = storeStockLot.txLotCode;
    Promise.all([FxFetch.doJsonX(`stock/lots/d`, record)]).then((result) => {
      if (result[0].theValue === 'OK') {
        navBack();
      }
    });
  }
  
  const formSaveCustom = () => {
    if (!r_boLotConfigLoaded.current) {
      r_snack_ask_save.current.setValAndOpen(trans('msg.lot_settings_not_loaded'));
      return;
    }

    if (r_form.current.hasIncompleteRequired()) {
      return;
    }

    let record = {};
    record['inPs'] = storeStockLot.inPs;
    record['txPs'] = storeStockLot.txPs;
    record['txLotCodeOri'] = storeStockLot.txLotCode;
    record['txLotCode'] = rf_txLotCode.current.getVal();
    record['dtLotExpr'] = rf_dtLotExpr.current.getVal();
    record['boActive'] = rf_boActive.current.getVal();
    record['txLotAlert'] = rf_txLotAlert.current.getVal();
    record['txUse'] = rf_txUse.current.getVal();

    Promise.all([FxFetch.doJsonX("stock/lots/cu", record)]).then((result) => {
      if (result[0] && result[0].theValue === 'OK') {
        navBack();
      } else {
        FxLog.errorx('MxStockroomLotForm.formSaveCustom', 'Could not save lot settings', result[0]);
        r_snack_ask_save.current.setValAndOpen(trans('msg.lot_settings_not_saved'));
      }
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.stockroom')}: ${trans('field.lot')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {/* botón borrar */}
            <CxIconButtonNew icon={<BiTrash/>} classType="ibs_iconbutton_toolbar" onClick={() => formDeleteCustom()} tooltip={trans('field.delete')} />

            {/* botón guardar */}
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >

        <CxStatic label={`${storeStockLot.txPs}`} border='none' fontcolor='var(--ibs_color_blue)' fontsize='12px' />

        <CxInput xref={rf_txLotCode} label={trans('field.lot')} maxLength="50" required />
        <CxDate xref={rf_dtLotExpr} label={trans('field.expiration')} required />
        <CxState
          mode="checkbox"
          xref={rf_boActive}
          label={trans('field.active_1')}
        />
        <CxInput
          xref={rf_txLotAlert}
          label={trans('field.alert')}
          maxLength="100"
        />
        <CxCombo
          xref={rf_txUse}
          label={trans('field.use')}
          list={[
            { id: 'x', type: `${trans('field.sales')}+${trans('field.purchases')}` },
            { id: 's', type: trans('field.sales') },
            { id: 'p', type: trans('field.purchases') }
          ]}
          autoSelectFirst
        />

        <CxAccordion xref={r_accordion_sold} title={trans('field.sold_p')} background={"var(--ibs_color_gray_light)"} color={"var(--ibs_color_black)"} defaultExpanded >
          <CxTable
            xref={r_table_sold}
            margin="-15px 0px 0px 0px"
            url="stock/lots/sold"
            filter={`n_invoice_item.txLotCode='${storeStockLot.txLotCode}'`}
            disabled='true'
            columns={[
              { id: "0", Header: "ID", accessor: "inInvoiceItem", show: false },
              { id: "1", Header: trans('field.date'), accessor: row => FxTable.cellToLocalDate(row["dtInvoice"]), width: '20%' },
              { id: "2", Header: trans('field.invoice'), accessor: "txInvoice", width: '20%' },
              { id: "3", Header: trans('field.client'), accessor: "txClient", width: '60%' },
            ]}
          />
        </CxAccordion>

      </GxForm>

      <CxSnackbar xref={r_snack_ask_save} severity="error" value={trans('msg.save_before')} />

    </div>
  );

}

export default MxStockroomLotForm;
